var LeftNav, PartialRenderer, ProductReviews;

LeftNav = require('../../left_nav/frontend/main');

ProductReviews = require('../../product_reviews/frontend/main');

PartialRenderer = require('./partial_renderer');

$(window).load(function() {
  var payload;
  Groupon.Performance.pageReady();
  payload = Groupon.Utils.getConfigFromDom();
  new LeftNav();
  new PartialRenderer(payload);
  return new ProductReviews(payload);
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvbXRydW9uZy9uYXBpc3RyYW5vL2J1aWxkLzE0Nzg4MTkxMzcwNzgtMzgwMDkvc3RhZ2luZy1wZXJmLTIwMTYuMTEuMDlfMjMuMzIvZ29vZHMtaG9tZXBhZ2UvbW9kdWxlcy9ob21lL2Zyb250ZW5kL21haW4uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvbXRydW9uZy9uYXBpc3RyYW5vL2J1aWxkLzE0Nzg4MTkxMzcwNzgtMzgwMDkvc3RhZ2luZy1wZXJmLTIwMTYuMTEuMDlfMjMuMzIvZ29vZHMtaG9tZXBhZ2UvbW9kdWxlcy9ob21lL2Zyb250ZW5kL21haW4uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsT0FBQSxHQUFVLE9BQUEsQ0FBUSw4QkFBUjs7QUFDVixjQUFBLEdBQWlCLE9BQUEsQ0FBUSxxQ0FBUjs7QUFDakIsZUFBQSxHQUFrQixPQUFBLENBQVEsb0JBQVI7O0FBRWxCLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxJQUFWLENBQWUsU0FBQTtBQUNiLE1BQUE7RUFBQSxPQUFPLENBQUMsV0FBVyxDQUFDLFNBQXBCLENBQUE7RUFDQSxPQUFBLEdBQVUsT0FBTyxDQUFDLEtBQUssQ0FBQyxnQkFBZCxDQUFBO0VBQ04sSUFBQSxPQUFBLENBQUE7RUFDQSxJQUFBLGVBQUEsQ0FBZ0IsT0FBaEI7U0FDQSxJQUFBLGNBQUEsQ0FBZSxPQUFmO0FBTFMsQ0FBZiJ9
